<template>
	<div class="info">
		<!-- 折叠面板开始 -->
		<el-collapse v-model="activeName" @change="handleChange">
			<el-collapse-item :name="index" class="collapse" v-for="(item, index) in Commodity" :key="index">
				<template slot="title">
					<span class="txt">{{ item.commodityNameL }}</span>
					<span class="selected"
						>已选中<span class="countNum">{{ item.selectNum }}</span
						>把{{ item.commodityNameL }}</span
					>
					<span class="folding" v-if="item.folding">展开</span>
					<span class="folding" v-else>收起</span>
				</template>

				<!-- id容器开始 -->
				<div id="container">
					<div class="item" v-for="(i, k) in item.commodityMessage" :key="k">
							<!-- --------------------------------- -->
						<div class="shoadw" v-if="i.shadow">
							<img src="../../../../../static/hook.png" alt="" />
						</div>

						<img :src="i.imgUrl" alt="" />
						<p class="title">{{ i.title }}</p>
						<p class="bianhao">
							编号：<span>{{ i.number }}</span>
						</p>
						<p class="guige">
							规格：<span>{{ i.specifications }}</span>
						</p>
						<el-row class="price">
							<el-col :span="14">￥{{ i.price }}</el-col>
							<el-col :span="12"
								><el-input-number
									v-model="i.num"
									@change="handleSelect($event, item)"
									:min="0"
									label="数量"
								></el-input-number
							></el-col>
						</el-row>
					</div>
				</div>
				<!-- id容器结束 -->
			</el-collapse-item>
		</el-collapse>
		<!-- 折叠面板结束 -->

		<p>我租赁的花卉绿植</p>
		<div class="tab">
			<el-table
				:data="tableData"
				style="width: 100%"
				:header-cell-style="{
					background: '#FDC400',
					color: 'rgba(255, 255, 255, 0.85)',
					fontSize: '14px',
					fontFamily: 'PingFangSC-Medium, PingFang SC',
					height: '36px',
				}"
			>
				<el-table-column prop="imgUrl" label="图片" width="200">
					<template slot-scope="scope">
						<img :src="scope.row.imgUrl" alt="因某种原因无法显示图片" />
					</template>
				</el-table-column>
				<el-table-column prop="name" label="展品名称" width="180"> </el-table-column>
				<el-table-column prop="Serial" label="编号" width="200"> </el-table-column>
				<el-table-column prop="specifications" label="规格" width="220"> </el-table-column>
				<el-table-column prop="zeroRent" label="零租" width="200"> </el-table-column>
				<el-table-column prop="count" label="租用数量" width="180"> </el-table-column>
				<el-table-column prop="state" label="状态"> </el-table-column>
			</el-table>
		</div>

		<!-- 轮播子元素 -->
		<div class="settlement">
			<div class="live" v-if="flag">
				<div class="select">已选中{{ listItems.length }}把家具</div>
				<div class="exhibitorsLive" id="swiper-tt">
					<swiper :options="swiperOption" ref="hits" :auto-update="true">
						<swiper-slide v-for="(item, index) in listItems" :key="index">
							<div class="img">
								<img :src="item.imgUrl" alt="" />
								<div class="btn">
									<el-input-number
										v-model="item.num"
										@input="handleItem($event,item)"
										
										label="描述文字"
									></el-input-number>
								</div>
							</div>
						</swiper-slide>
						<div class="swiper-button-prev" slot="button-prev"></div>
						<div class="swiper-button-next" slot="button-next"></div>
					</swiper>
				</div>
			</div>
			<span @click="close()" class="furniture"
				>已选中{{ selectCount }}把家具<i :class="[flag ? 'el-icon-arrow-down' : 'el-icon-arrow-up']"></i
			></span>
			<div class="money">
				总租金<span class="totalPrice">￥{{ totalRent }}</span>
			</div>
			<el-button type="primary" class="bn" @click="OpenSure()">提交</el-button>
		</div>

		<!--------------------------------------------------------------->
		<el-dialog title="请确认本次展具租赁清单" :visible.sync="sureTab" :before-close="CloseSure" width="fit-content">
			<div class="box">
				<div class="tabb">
					<table>
						<thead>
							<tr>
								<th>图片</th>
								<th>展品名称</th>
								<th>编号</th>
								<th>规格</th>
								<th>零租</th>
								<th>租用数量</th>
								<th>小计</th>
								<th>操作</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in listItems">
								<td><img :src="item.imgUrl" alt="" /></td>
								<td>{{ item.title }}</td>
								<td>{{ item.number }}</td>
								<td>{{ item.specifications }}</td>
								<td>{{ item.price }}</td>
								<td class="leaseCount">
									<div v-if="item.falg">{{ item.num }}</div>
									<div v-else>
										<el-input-numbers
											v-model="item.num"
											@change="handleChange(item)"
											:min="1"
											:max="10"
											label="描述文字"
										></el-input-numbers>
									</div>
								</td>
								<td>{{ item.price * item.num }}</td>
								<td>
									<div>
										<span v-if="item.falg" @click="rowEdit(item, index)"
											><i class="el-icon-edit-outline">编辑</i></span
										>
										<span v-else @click="rowSave(item, index)"
											><i class="el-icon-share">保存</i></span
										>
										<span @click="rowDelete(item, index)"><i class="el-icon-delete">删除</i></span>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="computed">
					<span class="selectex"
						>已选中 <span class="counter">{{ counter }}</span
						>把展具</span
					>
					<span class="leaseMoney"
						>总租金￥ <span class="totalPrice">{{ totalPrice }}</span></span
					>
					<span><el-button type="primary">确定</el-button></span>
				</div>
			</div>
		</el-dialog>
		<!--------------------------------------------------------------->
	</div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
export default {
	components: {
		swiper,
		swiperSlide,
	},
	data() {
		return {
			activeName: [], //默认打开第一个面板
			chairNum: 0, //已选择的商品数量
			//商品信息
			Commodity: [
				{
					commodityNameL: '绿植',
					selectNum: 0,
					folding: true,
						commodityMessage: [
						{
							imgUrl: require('../../../../../static/SFJ0065.jpg'),
							title: '异形',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '80',
							num: 0,
							shadow: false,
						},
						{
							imgUrl: require('../../../../../static/SFJ0064.jpg'),
							title: '异形吧椅',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '60',
							num: 0,
							shadow: false,
						},
						{
							imgUrl: require('../../../../../static/SFJ0001-1.jpg'),
							title: '异形吧椅',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '50',
							num: 0,
							shadow: false,
						},
						{
							imgUrl: require('../../../../../static/SFJ0001-2.jpg'),
							title: '异形吧椅',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '40',
							num: 0,
							shadow: false,
						},
						{
							imgUrl: require('../../../../../static/SFJ0001-3.jpg'),
							title: '异形吧椅',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '30',
							num: 0,
							shadow: false,
						},
						{
							imgUrl: require('../../../../../static/SFJ0055.jpg'),
							title: '异形吧椅',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '20',
							num: 0,
							shadow: false,
						},
						{
							imgUrl: require('../../../../../static/SFJ0057.jpg'),
							title: '异形吧椅',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '10',
							num: 0,
							shadow: false,
						},
						{
							imgUrl: require('../../../../../static/SFJ0059.jpg'),
							title: '异形吧椅',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '70',
							num: 0,
							shadow: false,
						},
						{
							imgUrl: require('../../../../../static/SFJ0060.jpg'),
							title: '异形吧椅',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '70',
							num: 0,
							shadow: false,
						},
						{
							imgUrl: require('../../../../../static/SFJ0061.jpg'),
							title: '异形吧椅',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '70',
							num: 0,
							shadow: false,
						},
					],
				},
				{
					commodityNameL: '花卉',
					selectNum: 0,
					folding: true,
					commodityMessage: [
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '桌子桌子桌子',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '70',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '桌子桌子',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '60',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '桌子桌子',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '50',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '异形吧椅',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '40',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '异形吧椅',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '30',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '异形吧椅',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '20',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '异形吧椅',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '10',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '异形吧椅',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '70',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '异形吧椅',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '70',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '异形吧椅',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '70',
							num: 0,
						},
					],
				},
				{
					commodityNameL: '瓶花',
					selectNum: 0,
					folding: true,
					commodityMessage: [
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '茶几茶几茶几',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '70',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '茶几茶几茶几',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '60',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '茶几茶几茶几',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '50',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '茶几茶几',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '40',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '茶几茶几',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '30',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '茶几茶几',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '20',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '茶几茶几',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '10',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '茶几茶几',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '70',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '茶几茶几',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '70',
							num: 0,
						},
						{
							imgUrl: require('../../../../../static/indexBanner.png'),
							title: '茶几茶几',
							number: 'SFJ0001',
							specifications: '360*400*710*930H白色',
							price: '70',
							num: 0,
						},
					],
				},
			],
			//我租赁的绿植花卉
			tableData: [
				{
					imgUrl: require('../../../../../static/indexBanner.png'),
					name: '异型吧台椅',
					Serial: 'SFJ0006',
					specifications: '450*400*8000H',
					zeroRent: '70',
					count: '2',
					state: '已提交',
				},
				{
					imgUrl: require('../../../../../static/indexBanner.png'),
					name: '异型吧台椅',
					Serial: 'SFJ0006',
					specifications: '450*400*8000H',
					zeroRent: '70',
					count: '2',
					state: '已提交',
				},
			],
			//swiper 初始化
			swiperOption: {
				pagination: '.swiper-pagination',
				loop: true,
				slidesPerView: 0,
				spaceBetween: 0,
				observer: true,
				observeParents: true,
				autoplay: {
					delay: 9999999900,
					stopOnLastSlide: false,
					disableOnInteraction: false,
				},
				// 显示分页
				pagination: {
					el: '.swiper-pagination',
					clickable: true, //允许分页点击跳转
				},
				// 设置点击箭头
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			},
			//折叠显示
			flag: false,
			//存放选中的数组
			selectArr: [],

			//存放选中的数据
			listItems: [],

			//确认提交面板
			sureTab: false,
		};
	},
	methods: {
		handleChange(val) {
			if (val.length == 0) {
				this.Commodity.forEach((item) => {
					this.$set(item, 'folding', true);
				});
				return false;
			} else {
				for (let i = 0; i < val.length; i++) {
					let index = val[i];
					this.Commodity[index].folding
						? this.$set(this.Commodity[index], 'folding', false)
						: console.log('');
				}
			}
		},
	//步进器触发函数
		handleSelect(value, item) {
			let a = 0;
			item.commodityMessage.forEach((i) => {
				a += i.num;
				console.log(i);
				if (i.num != 0) {
					i.shadow = true;
				} else {
					i.shadow = false;
				}
			});
			item.selectNum = a;
			this.settlement();
		},

		//循环遍历数据
		settlement() {
			this.selectArr = [];
			const that = this;
			this.Commodity.forEach((item) => {
				item.commodityMessage.forEach((i) => {
					if (i.num !== 0) {
						this.selectArr.push(i);
					}
				});
			});
			this.listItems = this.selectArr;
		},

		 unique(arr) {
             const res = new Map();
             return arr.filter((arr) =>
			    {
			         !res.has(arr.title) && res.set(arr.title, 1)
				}
			  );
        },



		handleCh(val) {
			console.log(val);
			console.log('1234565');
		},

		//阴影轮播函数
		handleItem(value,item) {
			console.log(value,item);
		},
		close() {
			console.log('阴影轮播面板关闭了！');
			this.flag = !this.flag;
		},

		//打开确认框
		OpenSure() {
			this.sureTab = true;
		},
		//关闭确认框
		CloseSure() {
			this.sureTab = false;
		},

		//-------------g购物车确定清单----------------------
		editor(value) {
			this.$nextTick(() => {
				if (value.num < 1) {
					this.$set(value, 'num', 0);
				} else {
					const count = value.num++;
					this.$set(value, 'num', count);
				}
			});
		},
		rowEdit(item, index) {
			item.falg = !item.falg;
		},
		rowSave(item, index) {
			item.falg = !item.falg;
		},
		rowDelete(item, index) {
			this.tableData.splice(index, 1);
		},
	},
	computed: {
		totalPrice() {
			let totalprice = 0;
			this.tableData.forEach((item, index) => {
				totalprice += item.zeroRent * item.count;
			});
			return totalprice;
		},
		counter() {
			let counter = 0;
			this.tableData.forEach((item, index) => {
				counter += item.count;
			});
			return counter;
		},
		//阴影计算总价
		totalRent() {
			let totalprice = 0;
			this.listItems.forEach((item, index) => {
				totalprice += item.num * item.price;
			});
			return totalprice;
		},
		//尾部已选好中家具数量
		selectCount() {
			let count = 0;
			this.listItems.forEach((item, index) => {
				count += item.num;
			});
			return count;
		},
	},
};
</script>
<style scoped lang="scss">
.info {
	box-sizing: border-box;
	position: relative;
	.selected {
		position: absolute;
		right: 100px;
		letter-spacing: 2px;
	}
	.folding {
		position: absolute;
		right: 35px;
		width: fit-content;
	}
	#container {
		display: grid;
		justify-content: space-between;
		grid-template-columns: repeat(auto-fill, 252px);
		grid-gap: 10px;
	}
	// item变化
	.item {
		border: 1px solid #e0e0e0;
		margin-top: 15px;
		padding-bottom: 15px;
	    position: relative;


	//------------------------------------------------------------------------
		.shoadw {
			position: absolute;
			top: 0px;
			left: 0px;
			width: 100%;
			height: 187px;
			background: rgba(0, 111, 184, 0.5);
 	        text-align: center;
			 line-height: 187px;   
			img {
				width: 33px;
				height: 25px;
				display: inline;
			
			}
		}

		//------------------------------------------------------------------------


		img {
			width: 100%;
			height: 187px;
		}
		.title {
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 800;
			color: #333333;
			line-height: 19px;
			padding-left: 17px;
			box-sizing: border-box;
			padding-top: 17px;
		}

		.bianhao {
			font-size: 12px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			line-height: 19px;
			padding-left: 17px;
			box-sizing: border-box;
			padding-top: 8px;
		}
		.guige {
			font-size: 12px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #666666;
			line-height: 19px;
			padding-left: 17px;
			box-sizing: border-box;

			padding-top: 8px;
		}
		.price {
			display: flex;
			justify-content: space-between;
			padding-left: 17px;
			box-sizing: border-box;
			padding-top: 8px;
		}
	}
	// item不变

	p {
		padding-top: 52px;
		padding-bottom: 9px;
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		line-height: 22px;
	}
	.tab {
		border-top: 1px solid #e9e9e9;
		height: fit-content;
		padding-top: 20px;
		img {
			width: 104px;
			height: 78px;
		}
	}
	.settlement {
		position: relative;
		display: flex;
		height: 30px;
		padding-top: 20px;
		.furniture {
			i {
				padding-left: 10px;
			}
		}
		.money {
			display: flex;
			position: relative;
			left: 25px;
			.totalPrice {
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 800;
				color: #ff190c;
				margin-left: 6px;
			}
		}
		.bn {
			position: absolute;
			right: 0px;
		}
	}
}
.countNum {
	color: red;
}
</style>
<style scoped>
.el-input-number {
	width: 91px;
	height: 24px;
	line-height: 24px;
}
.el-input-number >>> .el-input__inner {
	line-height: 24px !important;
	height: 24px !important;
	padding: 0px;
	border-radius: 3px;
}
.el-input-number >>> .el-input-number__decrease,
.el-input-number__increase {
	width: 24px !important;
	height: 22px !important;
}
.el-input-number >>> .el-input-number__increase {
	width: 24px !important;
	height: 22px !important;
}
.collapse >>> .el-collapse-item__header {
	border-bottom: 1px solid #006fb8 !important;
}
.settlement >>> .el-collapse-item__arrow {
	float: left;
	position: absolute;
	left: 90px;
}
.el-button--primary {
	font-size: 12px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #ffffff;
	width: 76px;
	height: 28px;
	line-height: 0px;
	background-color: #006fb8;
}
.collapse >>> .el-collapse-item__header {
	position: relative;
}
.el-collapse-item >>> .el-collapse-item__wrap {
	border-bottom: none !important;
}
.info >>> .el-collapse-item__content {
	padding-top: 15px !important;
}
.el-dialog__wrapper >>> .el-dialog__header {
	padding: 15px 20px 10px;
	background: #006fb8;
}
.el-dialog__wrapper >>> .el-dialog__title {
	font-size: 16px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #ffffff;
}
.el-dialog__wrapper >>> .el-dialog__close {
	color: #ffffff;
}
.el-dialog__wrapper >>> .el-dialog__body {
	padding: 20px 20px 0px 20px;
}
</style>
<style lang="scss" scoped>
.live {
	width: 100%;
	height: fit-content;
	background-color: rgba(29, 21, 21, 0.45);
	position: absolute;
	top: -300px;
	.select {
		font-size: 13px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #ffffff;
		padding-left: 25px;
		padding: 20px;
	}
	.img {
		width: 231px;
		height: 173px;
		margin: 0 auto;
		img {
			width: 231px;
			height: 173px;
		}
		.btn {
			display: flex;
			justify-content: center;
			padding-top: 10px;
		}
	}
	.exhibitorsLive {
		width: 100%;
		.swiper-slide {
		}
	}
}
</style>
<style scoped>
/*-------------------轮播图样式修改---------------------------*/
.swiper-slide {
	width: 310px;
	padding-bottom: 60px;
}
.el-input-number {
	width: 91px;
	height: 24px;
	line-height: 24px;
}
.el-input-number >>> .el-input__inner {
	line-height: 24px !important;
	height: 24px !important;
	padding: 0px;
	border-radius: 3px;
}
.el-input-number >>> .el-input-number__decrease,
.el-input-number__increase {
	width: 24px !important;
	height: 22px !important;
}
.el-input-number >>> .el-input-number__increase {
	width: 24px !important;
	height: 22px !important;
}
.exhibitorsLive >>> .swiper-wrapper {
	left: 0px;
}
/* 改变轮播图的箭头 */
.live >>> .swiper-button-prev {
	height: 20px;
	left: -1px;
	background-image: url("../../../../../static/icon-arrow-left.png");
}
.live >>> .swiper-button-next {
	height: 20px;
	right: -1px;
	background-image: url("../../../../../static/icon-arrow-right.png");
}
</style>
<style scoped lang="scss">
.box {
	border-radius: 2px 2px 0px 0px;
	.tabb {
		table {
			width: 100%;
			border-collapse: collapse;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			border-radius: 3px 3px 0px 0px;
			thead {
				background-color: #fdc400;
				border-radius: 10px;
				table-layout: fixed;
				tr {
					height: 36px;
					color: rgba(255, 255, 255, 0.85);
					width: 100%;
					display: block;
					th {
						box-sizing: border-box;
						height: 36px;
						width: 142px;
					}
				}
			}
			tbody {
				height: 450px;
				overflow-y: scroll;
				display: block;
				tr {
					display: block;
					td {
						text-align: center;
						width: 153px;
						img {
							width: 104px;
							height: 78px;
							margin: 10px 0px;
						}
						span {
							color: #006fb8;
							margin: 0px 5px;
						}
					}
					&:nth-child(even) {
						background-color: #f6f6f7;
					}
				}
			}
			.leaseCount {
				width: 100px;
				div {
					margin: 0 auto;
					text-align: center;
					width: 92px;
				}
			}
		}
	}

	.computed {
		//margin: 34px 26px 0px 26px;
		height: 46px;
		background-color: #ffffff;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		border-top: 1px solid rgba(0, 0, 0, 0.09);
		.selectex {
			margin-right: 26px;
			font-size: 12px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #666666;
			.counter {
				color: red;
				font-weight: 600;
				margin: 0px 5px;
			}
		}
		.leaseMoney {
			margin-right: 69px;
			font-size: 12px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #666666;
			.totalPrice {
				color: red;
				font-weight: 600;
				margin: 0px 5px;
			}
		}
	}
}
</style>
<style scoped>
/* -------------步进器相关函数-------------- */
.el-input-number {
	width: 91px;
	height: 24px;
	line-height: 24px;
}
.el-input-number >>> .el-input__inner {
	line-height: 24px !important;
	height: 24px !important;
	padding: 0px;
	border-radius: 3px;
}
.el-input-number >>> .el-input-number__decrease,
.el-input-number__increase {
	width: 24px !important;
	height: 22px !important;
}
.el-input-number >>> .el-input-number__increase {
	width: 24px !important;
	height: 22px !important;
}
.el-button--primary {
	font-size: 12px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #ffffff;
	/* width: 56px; */
	height: 28px;
	line-height: 0px;
	background-color: #006fb8;
	text-align: center;
}
</style>
